<script setup lang="ts">
//@ts-ignore
import type {PrimitiveProps} from "radix-vue";
import {computed, HTMLAttributes} from "vue";
import {cn} from '@/shared/lib/utils'

interface Props extends PrimitiveProps {
  label: string
  description?: string
  maxWidth?: number
  class?: HTMLAttributes['class']
  labelClass?: HTMLAttributes['class']
  descriptionClass?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {})

const maxClass = computed(() => {
  if (props.maxWidth === null) {
    return {}; // No max-width style is applied
  } else {
    return {
      'max-width': (props.maxWidth / 16) + 'rem',
    };
  }
});

</script>

<template>
  <div :class="cn('flex flex-col items-start', props.class)">
    <div class="flex items-center">
      <div :class="cn('text-sm font-medium text-gray-900 dark:text-white text-left flex items-start' )" :style="maxClass"
           data-tests="datarow-title">
        <slot name="labelBefore"/>
        <span :class="cn('inline-block truncate-2', props.labelClass)">{{ label }}</span>
        <slot name="labelAfter"/>
      </div>
    </div>
    <div v-if="description" :class="cn('text-sm font-normal text-slate-500 truncate')" :style="maxClass">
      <slot name="descriptionBefore"/>
      <span :class="cn('inline-block', props.descriptionClass)">{{ description }}</span>
      <slot name="descriptionAfter"/>
    </div>
  </div>
</template>

<style scoped>

</style>